import React from 'react';
import { Table, Card, Tooltip, Avatar, Skeleton } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  PrimaryTableRowText,
  TableColumnTitle,
} from '../../../../../../shared/globalStyling/styledText';
import moment from 'moment';
import cnnaid from '../../../../../../../assets/icons/transactions/cnnaid.png';
import cnnaip from '../../../../../../../assets/icons/transactions/cnnaip.png';
import cnnafingerprint from '../../../../../../../assets/icons/transactions/cnnafingerprint.png';
import { ReactComponent as GlobePhoneIcon } from '../../../../../../../assets/icons/transactions/globephone.svg';
import {
  DesktopOutlined,
  MobileOutlined,
  TableOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import SessionExpand from './SessionExpand';
import { secondsToTimeText } from '../../../../utils/secondsToTimeText';
import { SESSIONS_TOOLTIP } from '../../../../../../shared/constants/tooltips';

const SessionsTable = ({ data = [], loading = false, total }) => {
  const columns = [
    {
      title: <TableColumnTitle text={'Session ID'} />,
      index: 'sessionId',
      key: 'sessionId',
      render: (text, { sessionId }) => {
        return <PrimaryTableRowText text={sessionId} />;
      },
    },
    {
      title: <TableColumnTitle text={'Start Time'} />,
      index: 'start',
      key: 'start',
      render: (text, { start }) => {
        return <PrimaryTableRowText text={moment(start).format('YYYY-MM-DD HH:mm:ss')} />;
      },
    },
    {
      title: <TableColumnTitle text={'End Time'} />,
      index: 'end',
      key: 'end',
      render: (text, { end }) => {
        return <PrimaryTableRowText text={moment(end).format('YYYY-MM-DD HH:mm:ss')} />;
      },
    },
    {
      title: <TableColumnTitle text={'Duration'} />,
      index: 'durationInSeconds',
      key: 'durationInSeconds',
      render: (text, { durationInSeconds }) => {
        return <PrimaryTableRowText text={secondsToTimeText(durationInSeconds)} />;
      },
    },
    {
      title: <TableColumnTitle text={'Attr. Page Views'} />,
      index: 'pageViews',
      key: 'pageViews',
      render: (text, { clicks }) => {
        return <PrimaryTableRowText text={clicks} />;
      },
    },
    {
      title: <TableColumnTitle text={'Session Page Views'} />,
      index: 'pageViews',
      key: 'pageViews',
      render: (text, { pageViews }) => {
        return <PrimaryTableRowText text={pageViews} />;
      },
    },
    {
      title: <TableColumnTitle text={'Landing Page'} />,
      index: 'landingPage',
      key: 'landingPage',
      render: (text, { landingPage }) => {
        return <PrimaryTableRowText text={landingPage} />;
      },
    },
    {
      title: <TableColumnTitle text={'Exit Page'} />,
      index: 'exitPage',
      key: 'exitPage',
      render: (text, { exitPage }) => {
        return <PrimaryTableRowText text={exitPage} />;
      },
    },
    {
      title: <TableColumnTitle text={''} />,
      index: 'deviceType',
      key: 'deviceType',
      render: (text, { deviceType }) => {
        const getIcon = () => {
          if (deviceType.toLowerCase() === 'mobile') {
            return <MobileOutlined />;
          } else if (deviceType.toLowerCase() === 'tablet') {
            return <TableOutlined />;
          }
          return <DesktopOutlined />;
        };
        return (
          <>
            {getIcon()}
            {deviceType}
          </>
        );
      },
    },
    {
      title: <TableColumnTitle text={''} />,
      dataIndex: 'attributionMethod',
      key: 'attributionMethod',
      align: 'left',
      width: '8%',
      render: (text, { attributionMethod }) => {
        let attributionIcon = cnnaip;
        let tip = '';
        //Single object with 1 key
        if (attributionMethod) {
          if (attributionMethod === 'COOKIE') {
            attributionIcon = cnnaid;
            tip = 'Cookie Match - Deterministic match using browser based cookie / uuid match.';
          } else if (attributionMethod === 'FINGERPRINT') {
            attributionIcon = cnnafingerprint;
            tip =
              'User Match - Probabilistic match using user fingerprint. (User fingerprint - The combination of user agent and IP address to produce a unique hash)';
          } else if (attributionMethod === 'DEVICE_FINGERPRINT') {
            tip =
              'Device Match - Probabilistic match using user device model information (Device model, OS, OS version ) combined with IP address';
          } else if (attributionMethod === 'IP') {
            tip = 'IP Match - Probabilistic match using IP address.';
            attributionIcon = cnnaip;
          }
        }
        const attributionIcn = () => {
          if (attributionMethod === 'DEVICE_FINGERPRINT') {
            return (
              <span role="img" className="anticon" style={{ verticalAlign: '-5px' }}>
                <GlobePhoneIcon
                  height="35"
                  width="35"
                  style={{
                    opacity: '1.0',
                  }}
                />
              </span>
            );
          } else {
            return <Avatar src={attributionIcon} />;
          }
        };
        return <Tooltip title={tip}>{attributionIcn()}</Tooltip>;
      },
    },
  ];
  return (
    <React.Fragment>
      <Card
        title={
          <span>
            Sessions{' '}
            <Tooltip title={SESSIONS_TOOLTIP}>
              <QuestionCircleOutlined style={{ color: '#1890ff', marginLeft: '4px' }} />
            </Tooltip>
          </span>
        }
      >
        {loading ? (
          <Skeleton active />
        ) : (
          <>
            <Table
              dataSource={data}
              columns={columns}
              pagination={{
                position: ['none', 'bottomCenter'],
                total: total ? total : data.length,
                responsive: true,
                showSizeChanger: false,
                showLessItems: true,
                size: 'default',
              }}
              rowKey={({ sessionId }) => sessionId}
              scroll={{ x: 1200, y: 1700 }}
              expandedRowRender={(record) => {
                const { clicksList, sessionJourney } = record;
                return <SessionExpand clicksList={clicksList} journey={sessionJourney} />;
              }}
            />
          </>
        )}
      </Card>
    </React.Fragment>
  );
};

export default withRouter(SessionsTable);
